
/**
 * Custom component for Bimini default menu sections.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.2.0
 * @copyright  Copyright (C) 2023-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *  2023-06-07 (1.0.0) (jhoward)
 *    - Copy from PanchoWillies_defaultSection.vue component to Chi_defaultSection.vue component.
 *
 *  2023-08-18 (1.0.1) (jhoward)
 *    - Add custom intro page CSS to <Chi_defaultSection>.
 *
 *  2023-08-28 (1.1.0) (jhoward)
 *    - Use <menu-version> in <Chi_defaultSection>.
 *
 *  2025-02-11 (1.2.0) (jhoward)
 *    - Add <menu-schedules> to the <Chi_defaultSection> component if in admin view.
 */

import MenuTagLegend from "../../menu-tag-legend.vue";
import {
  computeItemGroupPricingTypes,
  computeSectionSubtitle,
  computeSectionTitle
} from "../../../../helpers/menu-sections";
import MenuContentArea from "../../menu-content-area.vue";
import {defineComponent, PropType} from "vue";
import {
  ALLOWED_ITEM_COMPONENTS,
  Menu,
  MENU_ITEM_GROUP_LAYOUT,
  MENU_ITEM_TAG_LOCATIONS,
  MenuSection, SECTION_CONTENT_AREA_BOTTOM_LAYOUT,
  SECTION_CONTENT_AREA_TOP_LAYOUT
} from "../../defs";
import MenuItemGroup from "../../menu-item-group.vue";
import MenuVersion from "../../menu-version.vue";
import MenuSchedules from "../../schedule/MenuSchedules.vue";

export default defineComponent({
  components: {
    MenuSchedules,
    MenuVersion,
    MenuItemGroup,
    MenuContentArea,
    MenuTagLegend,
  },
  name: "default-visual-section",
  props: {
    menu: {
      type: Object as PropType<Menu>,
      required: true
    },
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
    sectionModifier: {
      type: String,
      default: ''
    },
    menuItemComponent: {
      type: String,
      required: true,
      validate: (value: string) => '' === value || ALLOWED_ITEM_COMPONENTS.indexOf(value)
    },
    menuItemTagLocation: {
      type: String as PropType<MENU_ITEM_TAG_LOCATIONS>,
      default: ''
    },
    itemGroupLayout: {
      type: String as PropType<MENU_ITEM_GROUP_LAYOUT>,
      default: ''
    },
    contentAreaTopLayout: {
      type: String as PropType<SECTION_CONTENT_AREA_TOP_LAYOUT>,
      default: ''
    },
    contentAreaBottomLayout: {
      type: String as PropType<SECTION_CONTENT_AREA_BOTTOM_LAYOUT>,
      default: ''
    },
    isTagLegendHidden: {
      type: Boolean,
      default: false
    },
    isTitleBoxVisible: {
      type: Boolean,
      default: false
    },
    isTitleBufferVisible: {
      type: Boolean,
      default: false
    },
    sectionMenuType: {
      type: String,
      default: ''
    },
  },
  data: function () {
    return {};
  },
  computed: {
    itemGroupPricingTypes: computeItemGroupPricingTypes,
    sectionTitle: computeSectionTitle,
    sectionSubtitle: computeSectionSubtitle,

    containerClasses: function () {
      return {
        'menu--section-show_bin': !!this.section.ms_show_bin,
        'menu--section-show_pricing_header': !!this.section.ms_show_pricing_header,
        'menu--section-group_by_price': !!this.section.ms_group_by_price,
        'menu--section-highlight': !!this.section.ms_highlight,
        'menu--section-desserts': this.section.ms_title.toLowerCase() === 'desserts',
      };
    }
  },
  methods: {
    getFormattedPrice: function (price: string): string {
      return price.replace(/\$/g, '');
    }
  },
})
